import React from 'react';
import { Container, AuthService } from '../../../symphony';
import { AINavbar } from '../components/AINavbar/AINavbar';

export const AINavigationContainer = () => {
  const authService = Container.take('global', AuthService);

  return <AINavbar />;
};